import React from "react";

import Error from "../Error/Error";
import Layout from "./Layout";

const ErrorPage = (props: React.ComponentProps<typeof Layout> & React.ComponentProps<typeof Error>) => {
    const {
        pageName = "error-page",
        pageId = "error-content",
        user,
        recommendationCards,
        handleModalFormSubmit = () => {
            console.error("Design System: Newsletter handleModalFormSubmit not supplied to the ErrorPage!");
            return Promise.resolve(false);
        }
    } = props;

    return (
        <Layout pageName={pageName} pageId={pageId} user={user} handleModalFormSubmit={handleModalFormSubmit}>
            <Error recommendationCards={recommendationCards} />
        </Layout>
    );
};

export { ErrorPage as default };
